import { render } from "./BrandComponent.vue?vue&type=template&id=ab50c298&scoped=true"
import script from "./BrandComponent.vue?vue&type=script&lang=js"
export * from "./BrandComponent.vue?vue&type=script&lang=js"

import "./BrandComponent.vue?vue&type=style&index=0&id=ab50c298&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab50c298"]])

export default __exports__